import React, { useState } from 'react'
import { DI, DIProps } from '../../../../Core';
import { getTags } from '../Utils/Helper';
import { Card, InlineStack, Icon, Popover, Tag, Text } from '@shopify/polaris';
import { ChevronDownMinor } from '@shopify/polaris-icons';
interface props extends DIProps {
    row: any
}

const RenderTags = (props: props) => {
    const [popoverActive, setPopoverActive] = useState<boolean>(false);

    /**
     * Renders the tag structure based on the provided row data.
     * @returns {React.ReactNode} The JSX representation of the tag structure.
     */
    const renderTagStructure = (): React.ReactNode => {
        let render: React.ReactNode = <></>;
        let { primaryTag, remainingCount, remaingingTags } = getTags(props.row);

        if (primaryTag !== '') {
            if (remainingCount > 0) {
                render = <InlineStack gap="200" blockAlign='center' key={'countGreaterThan0'} wrap={false}>
                    <Tag>{primaryTag}</Tag>
                    <Text as="p" fontWeight="bold"> +{remainingCount}</Text>
                    <div style={{ cursor: 'pointer' }}>
                        <Popover
                            active={popoverActive}
                            preferredAlignment="right"
                            activator={<div onClick={() => setPopoverActive(!popoverActive)}><Icon source={ChevronDownMinor} tone="subdued" /></div>}
                            autofocusTarget="first-node"
                            onClose={() => setPopoverActive(!popoverActive)}
                        >
                            <Card padding="300">
                                {remaingingTags?.map((tags: any, idx: number) => <Tag key={idx}>{tags}</Tag>)}
                            </Card>
                        </Popover>
                    </div>
                </InlineStack>
            }
            else {
                render = <InlineStack gap="200" blockAlign='center' key={'elseCase'}>
                    <Tag>{primaryTag}</Tag>
                </InlineStack>
            }
        }
        else render = <Text as='p'>N/A</Text>

        return render;
    }

    return <React.Fragment>
        {renderTagStructure()}
    </React.Fragment>
}

export default DI(RenderTags)